import { executeSafelyWithLogging } from '@/services/errors-handler'
import { FeatureFlagProvider } from '@sennder/shell-utilities'

export const featureFlag = new FeatureFlagProvider({
  maskSensitiveData: true,
  unmaskedKeys: ['tenant', 'email'],
})

/** Enables tracking used for metrics creation in LaunchDarkly. Errors are caught and logged without throwing. */
export const startFeatureFlagTracking = () => {
  executeSafelyWithLogging(
    () => featureFlag.enableTracking(),
    'featureFlag.enableTracking'
  )
}

/** Enables tracking used for metrics creation in LaunchDarkly. Errors are caught and logged without throwing. */
export const stopFeatureFlagTracking = () => {
  executeSafelyWithLogging(
    () => featureFlag.disableTracking(),
    'featureFlag.disableTracking'
  )
}
